import { deleteSession } from '@usehatchapp/javascript-sdk';
import { deleteImpersonationSession } from 'utils/impersonationSession';

import { HATCH_APP_ROUTE, LOGIN } from '../../routes/APP_URLS';
import { userConstants } from '../constants';

// delete an active session
export const doDeleteSession =
  () =>
  async ({ dispatch, request }) => {
    const { DELETE_SESSION_FAILURE, DELETE_SESSION_SUCCESS } = userConstants;

    try {
      // delete impersonation session
      deleteImpersonationSession();

      // delete the user session
      await request(deleteSession);

      // tell state logout was successful
      dispatch({ type: DELETE_SESSION_SUCCESS });

      // reset all state
      dispatch({ payload: {}, type: 'REPLACE_STATE' });

      // send user to V2 login page
      return window.location.replace(HATCH_APP_ROUTE);
    } catch (error) {
      // error logging out
      dispatch({ error, type: DELETE_SESSION_FAILURE });

      // reset all state
      dispatch({ payload: {}, type: 'REPLACE_STATE' });

      // try to send them to login page anyway
      return dispatch({ actionCreator: 'doUpdateUrl', args: [LOGIN] });
    }
  };
